import type { ReactNode } from 'react'

import Image from 'next/image'
import { cn } from '@/lib/utils'

interface MediaProps {
    src: string
    alt: string
    sizes?: string
    priority?: boolean
    grain?: boolean
    className?: string
    imageClassName?: string
    children?: ReactNode
}

/**
 * Photography frame. Adds film grain and recolours to red-light mode.
 * The frame needs a size from its parent (aspect ratio or explicit height).
 */
export const Media = ({
    src,
    alt,
    sizes = '100vw',
    priority = false,
    grain = true,
    className,
    imageClassName,
    children
}: MediaProps): ReactNode => {
    return (
        <div className={cn('media', grain && 'media-grain', className)}>
            <Image
                src={src}
                alt={alt}
                fill
                sizes={sizes}
                priority={priority}
                unoptimized={/^(https?:)?\/\//.test(src)}
                className={cn('object-cover', imageClassName)}
            />
            {children}
        </div>
    )
}
